module.exports = __webpack_public_path__ + "static/results_icon-ec2c64840479839a7ba0ba4d36dfdbe0.svg";